import MiRegister from './register';
import { install } from '../../utils/install';
export default install(MiRegister);
